module.exports = __webpack_public_path__ + "img/bank_13.998a11cc.png";